import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box component="footer" sx={{ py: 6, textAlign: "center", backgroundColor: "transparent" }}>
      <Typography variant="body2">
        © {new Date().getFullYear()} Mariko Kumanomido
      </Typography>
    </Box>
  );
};

export default Footer;
